import store from '@/store'
import { getToken } from '@/utils/auth'
import { isTokenExpired } from '@/utils/jwt'

export function registerGuards(router) {
  router.beforeEach(async (to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
    const token = getToken()

    if (token && isTokenExpired(token)) {
      await store.dispatch('auth/logout')
      return next({ name: 'Login', query: { redirect: to.fullPath } })
    }

    const isLoggedIn = store.getters['auth/isLoggedIn']

    if (!requiresAuth && isLoggedIn) {
      return next({ name: 'Dashboard' })
    }

    if (requiresAuth && !isLoggedIn) {
      return next({ name: 'Login', query: { redirect: to.fullPath } })
    }

    return next()
  })

  router.afterEach((to) => {
    document.title = to.meta.title ? `${to.meta.title} · ControlLabs` : 'ControlLabs'
  })
}
